export default __webpack_public_path__ + "static/media/fridge2-afterA-2048w.e4273be0.png";